// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"626":"bc91df1a","958":"d99e1fb9"}[chunkId] + ".chunk.js";
};